export const DEFAULT_SPACE_COLOR = "#abadad";
